import {
  ByStatChartTypes,
  ByTargetChartTypes,
  WidgetChartType,
  WidgetTimePeriod,
  WidgetTimePeriodList,
} from '@/dashboard/shared/types/widgets.types';
import { BY_STAT_CHART_TYPES, BY_TARGET_CHART_TYPES, FIXED_DATA_ID } from '../constants/define';
import { isEqual } from 'lodash-es';

/**
 * WidgetTimePeriod 타입인지 확인
 * @param timePeriod - 확인할 시간 주기 값
 * @returns WidgetTimePeriod 타입인지 여부
 */
export const isWidgetTimePeriod = (timePeriod: any): timePeriod is WidgetTimePeriod => {
  return WidgetTimePeriodList.includes(timePeriod as WidgetTimePeriod);
};

/**
 * ByTargetChartType인지 확인
 * @param chartType - 확인할 차트 타입
 * @returns ByTargetChartTypes 타입인지 여부
 */
export const isByTargetChartType = (
  chartType: WidgetChartType,
): chartType is ByTargetChartTypes => {
  return BY_TARGET_CHART_TYPES.includes(chartType as ByTargetChartTypes);
};

/**
 * ByStatChartType인지 확인
 * @param chartTypeInfo - 확인할 차트 타입 정보
 * @returns ByStatChartTypes 타입인지 여부
 */
export const isByStatChartType = (chartTypeInfo: {
  chartType: string;
  displayStyle: string;
}): chartTypeInfo is ByStatChartTypes => {
  return BY_STAT_CHART_TYPES.some((typeInfo) => isEqual(typeInfo, chartTypeInfo));
};

/**
 * FixedDataId인지 확인
 * @param dataId - 확인할 데이터 ID
 * @returns FIXED_DATA_ID의 키인지 여부
 */
export const isFixedDataId = (dataId: any): dataId is keyof typeof FIXED_DATA_ID => {
  return Object.values(FIXED_DATA_ID).includes(dataId);
};
